export const PCT_CALC_TYPES = ['PCT_OFF', 'MAX_ALLOWED_PCT'];
